import * as React from 'react'
import { TrustpilotLogoIcon } from 'primitives/icons/social'
import { Star01FilledIcon } from 'primitives/icons/shapes'
import { Link } from '@repo/web-ui/components/link'
import Image from 'next/image'
import { tw } from 'utils/classnames'
interface PartnerRatingCardProps {
  image: {
    src: string
    alt: string
    width: number
    height: number
  }
  name: string
  copy: React.ReactNode
  starsNb: number
  reviews: string
  cta: {
    text: string
    href: string
    target: string
  }
  className?: string
}

export function PartnerRatingCard({
  image,
  name,
  copy,
  starsNb,
  reviews,
  cta,
  className,
}: PartnerRatingCardProps) {
  const { src, alt, width, height } = image
  const imageTwClasses = `h-[${image.height}px] w-[${image.width}px]`

  return (
    <div
      className={tw('flex w-full flex-col items-center gap-4 overflow-hidden md:w-auto', className)}
    >
      <div className="rounded-4 flex flex-[1_0_auto] flex-col items-center justify-between self-stretch border border-[#D9D9D9] bg-[#F8F8FA] px-10 py-8">
        <div className="flex h-[205px] w-[396px] max-w-[100%] items-center justify-center">
          <Image
            src={src}
            alt={alt}
            width={width}
            height={height}
            className={tw('w-full object-contain', imageTwClasses)}
          />
        </div>
        <div className="text-center">
          <h3 className="text-[15px] font-semibold leading-[22.5px] text-gray-600">{name}</h3>
          <p className="text-15 mt-1 text-center leading-[22.5px] text-gray-600">{copy}</p>
        </div>
        <div className="text-center">
          <div className="mt-6 flex items-center gap-5">
            <TrustpilotLogoIcon />
            <div className="flex gap-1">
              {Array.from({ length: starsNb }).map((_, index) => (
                <Star01FilledIcon key={index} className="h-[24px] w-[24px] text-[#00B67A]" />
              ))}
            </div>
          </div>
          <p className="text-13 mt-1 text-gray-500">{reviews}</p>
        </div>
      </div>
      <Link
        href={cta.href}
        target={cta.target}
        className="rounded-2 text-service-white text-13 hover:bg-vio flex h-[48px] w-fit items-center justify-center bg-violet-500 px-[21px] py-[10px] font-[500] hover:bg-[#6844C9] active:bg-[#552DC1]"
      >
        {cta.text}
      </Link>
    </div>
  )
}
